export default __webpack_public_path__ + "static/media/hht2_ep02_timeline_q04_b.13f5a599.png";